import { createAction } from 'redux-actions';
import { SET_LOCALE, USER_SIZE_UNIT_MM, USER_SIZE_UNIT_INCH } from '@/constants';
import { isWebComponentEnvironment } from '@/helpers';
import { setUserSizeUnit } from '@/actions';

export const changeLocale = (newLocale) => (dispatch, getState) => {
  const { core: { locale, userSizeUnit } } = getState();

  if (isWebComponentEnvironment()) {
    const localeCode = newLocale === 'en-US' ? 'en' : newLocale;
    const newUserUnit = newLocale === 'en-US' ? USER_SIZE_UNIT_INCH : USER_SIZE_UNIT_MM

    if (locale !== localeCode) {
      dispatch(createAction(SET_LOCALE, () => localeCode)());
    }
    if (userSizeUnit !== newUserUnit) {
      dispatch(setUserSizeUnit(newUserUnit));
    }
  } else {
    if (locale !== newLocale) {
      dispatch(createAction(SET_LOCALE, () => newLocale)());
    }
  }
}
